import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChecklistManagementTable = ({ checklists, sites, onEdit, onDelete, onRestore, loading }) => {
  const getSiteName = (siteId) => {
    const site = sites?.find(s => s?.id === siteId);
    return site?.site_name || 'Unknown Site';
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent"></div>
      </div>
    );
  }

  if (checklists?.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="flex justify-center mb-4">
          <div className="flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full">
            <Icon name="ClipboardList" size={32} color="var(--color-accent)" />
          </div>
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">No Checklist Templates</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Create your first checklist template to get started
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Checklist Name</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Site</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Items</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Created</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">Actions</th>
          </tr>
        </thead>
        <tbody>
          {checklists?.map((checklist) => (
            <tr key={checklist?.id} className="border-b border-border hover:bg-accent/5 transition-colors">
              <td className="py-3 px-4">
                <div>
                  <p className="text-sm font-medium text-foreground">{checklist?.checklist_name}</p>
                  {checklist?.description && (
                    <p className="text-xs text-muted-foreground mt-1">{checklist?.description}</p>
                  )}
                </div>
              </td>
              <td className="py-3 px-4">
                <p className="text-sm text-foreground">{getSiteName(checklist?.site_id)}</p>
              </td>
              <td className="py-3 px-4">
                <span className="inline-flex items-center gap-1 px-2 py-1 bg-accent/10 text-accent rounded-md text-xs font-medium">
                  <Icon name="List" size={14} />
                  {checklist?.checklist_items?.length || 0} items
                </span>
              </td>
              <td className="py-3 px-4">
                <p className="text-sm text-muted-foreground">
                  {new Date(checklist?.created_at)?.toLocaleDateString()}
                </p>
              </td>
              <td className="py-3 px-4">
                <div className="flex items-center justify-end gap-2">
                  <Button
                    size="sm"
                    variant="ghost"
                    iconName="Eye"
                    onClick={() => onEdit(checklist)}
                    title="View details"
                  />
                  {/* NSherjFh PR 8: admin Delete (active view) or Restore
                      (deleted view), mutually exclusive at the page level. */}
                  {onDelete && (
                    <Button
                      size="sm"
                      variant="ghost"
                      iconName="Trash2"
                      onClick={() => onDelete(checklist)}
                      title="Delete template"
                    />
                  )}
                  {onRestore && (
                    <Button
                      size="sm"
                      variant="ghost"
                      iconName="RotateCcw"
                      onClick={() => onRestore(checklist)}
                      title="Restore template"
                    />
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ChecklistManagementTable;